import { EuiEmptyPrompt, EuiImage, EuiButton, useEuiTheme } from '@elastic/eui';

import pageNotFoundDark from '@/assets/img/pageNotFound--dark.png';
import pageNotFoundLight from '@/assets/img/pageNotFound.png';
import pageNotFoundDark2x from '@/assets/img/pageNotFound--dark@2x.png';
import pageNotFoundLight2x from '@/assets/img/pageNotFound@2x.png';
import { useConfig } from '@/shared/contexts/config';

const defaultTitle = 'Page not found';
const defaultDescription =
  "We can't find the page you're looking for. It might have been removed, renamed, or it didn't exist in the first place.";
const defaultImageAlt =
  "An outer space illustration. In the background is a large moon and two planets. In the foreground is an astronaut floating in space and the numbers '404'.";
const defaultCTA = 'Home';

export type NotFoundProps = {
  title?: string;
  description?: string;
  cta?: string;
  ctaLink?: string;
  imageAlt?: string;
};

export const NotFound = ({
  title = defaultTitle,
  description = defaultDescription,
  cta = defaultCTA,
  ctaLink,
  imageAlt = defaultImageAlt,
}: NotFoundProps) => {
  const { appUrl } = useConfig();
  const { colorMode } = useEuiTheme();
  const isDarkTheme = colorMode === 'DARK';
  const link = ctaLink ?? appUrl;

  const pageNotFound = isDarkTheme ? pageNotFoundDark : pageNotFoundLight;
  const pageNotFound2x = isDarkTheme ? pageNotFoundDark2x : pageNotFoundLight2x;

  return (
    <EuiEmptyPrompt
      color="subdued"
      icon={
        <EuiImage
          size="fullWidth"
          srcSet={`${pageNotFound} 1x, ${pageNotFound2x} 2x`}
          src={pageNotFound}
          alt={imageAlt}
        />
      }
      title={<h2>{title}</h2>}
      layout="vertical"
      body={<p>{description}</p>}
      actions={[
        <EuiButton key="goHome" color="primary" fill href={link}>
          {cta}
        </EuiButton>,
      ]}
    />
  );
};
